window.Form = function (idForm, params) {
    var self = this;
    self.idform = idForm != '' ? '#' + idForm : '';
    self.form = self.idform != '' ? $('body ' + self.idform) : '';
    self.ajForm = new Aj();
    self.recaptcha = false;
    self.action = '';

    self.go_to_first_error = false;
    self.offset_error = 50;

    self.loader_on_button = false;

    if (typeof params !== 'undefined') {
        jQuery.extend(true, self, params);
    }

    self.$form = function () {
        if (self.form.length <= 0 && self.idform != '') {
            if ($('body ' + self.idform).length > 0) {
                self.form = $('body ' + self.idform);
            }
        }
        return self.form;
    }

    self.addSpin = function () {
        if (!self.loader_on_button) {
            Spin.add(self.$form());
        } else {
            Spin.loaderBtn(self.$form().find('input[type="submit"]'));
        }
    }

    self.removeSpin = function () {
        if (!self.loader_on_button) {
            Spin.remove(self.$form());
        } else {
            Spin.removeLoaderBtn(self.$form().find('input[type="submit"]'));
        }
    }

    self.sendForm = function () {
        if (self.$form().length <= 0) return false;
        self.addSpin();
        var url = self.$form().attr('data-action');
        self.setParamForm(url);
        self.ajForm.send_ajax_file('post', 'json', function (resp) {
            self.removeSpin();
            $('.error_ajax_custom').remove();
            switch (resp.status) {
                case "success":
                    self.callbackSuccessDefault(resp);
                    break;
                case "error":
                    self.callbackErrorDefault(resp);
                    break;
                default:
                    Notify.toastError("Errore di sistema");
                    break;
            }
        }, function () {
            self.removeSpin();
            Notify.toastError('Errore di sistema');
        });
    }
    self.setParamForm = function (url) {
        self.ajForm.url = url;
        self.ajForm.dati = new Array();
        if (self.action != '') {
            self.ajForm.add_mod_data('action', self.action)
        }
        self.ajForm.add_div_data(self.$form());
    }
    self.callbackSuccessDefault = function (resp) {
        self.$form().html('<h2>' + resp.message + '</h2>');
    }

    self.callbackErrorDefault = function (resp) {
        if (typeof resp.message !== 'undefined' && resp.message !== null) {
            Notify.toastError(resp.message);
        }

        var data = resp.data;
        if (typeof data.fields !== 'undefined' && data.fields !== null) {
            var first_error = true;
            for (var key in data.fields) {
                var search_key = key;
                var error_field = data.fields[key];
                var $elem_input = false;

                if (Array.isArray(error_field)) {
                    search_key = key + '[]';
                    error_field = error_field.join();
                }
                if (self.$form().find("[name='" + search_key + "']").length <= 0) {
                    search_key = key + '[]';
                    if (self.$form().find("[name='" + search_key + "']").length <= 0) {
                        const regex = /(.*)\[([0-9])+\]$/s;
                        const str = key;
                        let m;

                        if ((m = regex.exec(str)) !== null) {
                            search_key = "[name='" + m[1] + "[]']:eq(" + m[2] + ")";
                            if (self.$form().find(search_key).length > 0) {
                                $elem_input = self.$form().find(search_key)
                            } else {
                                continue;
                            }
                        } else {
                            continue
                        }
                    }
                }
                if ($elem_input === false) {
                    $elem_input = self.$form().find("[name='" + search_key + "']").last()
                }

                var stringa_errore = "" +
                    "<label class=\"form-text m-b-none error error_ajax_custom w-100\">" +
                    "" + error_field + "" +
                    "</label>" +
                    "";

                var $container_error = $elem_input.parent();
                $container_error.append(stringa_errore);

                if (self.go_to_first_error && first_error) {
                    first_error = false;
                    $('html, body').animate({
                        scrollTop: $container_error.offset().top - self.offset_error
                    }, 500);
                }
            }
        }
    }

    /*==Eventi==*/
    $('body').on('submit', self.idform, function (e) {
        e.preventDefault();
        self.sendForm();
        return false;
    });
}
